module.exports = __webpack_public_path__ + "static/img/hanekakushi_ka.5eadce3.jpg";